/* Keauty shipping goals. Thresholds come in data-milestone-currency (local currency, or the shop currency to convert). */
(() => {
  'use strict';
  if (window.keautyShippingGoals) { window.keautyShippingGoals.update(); return; }

  function calculate(milestones, total, rate) {
    if (!Array.isArray(milestones) || !milestones.length || !Number.isFinite(total) || total < 0 || !Number.isFinite(rate) || rate <= 0) return null;
    const converted = milestones.map(m => ({ ...m, cents: Math.ceil(Number(m.t) * rate * 100) }));
    if (converted.some((m, i) => !Number.isFinite(m.cents) || m.cents <= 0 || (i && m.cents <= converted[i - 1].cents))) return null;
    const next = converted.find(m => total < m.cents);
    const target = next || converted[converted.length - 1];
    return { target, unlocked: !next, remaining: next ? next.cents - total : 0, progress: Math.min(total / target.cents, 1) };
  }
  const formatMoney = (minor, currency) => {
    const value = minor / 100;
    const options = { style: 'currency', currency, currencyDisplay: 'symbol' };
    if (Number.isInteger(value)) { options.minimumFractionDigits = 0; options.maximumFractionDigits = 0; }
    return new Intl.NumberFormat(document.documentElement.lang || navigator.language, options).format(value);
  };

  function update(cart) {
    for (const root of document.querySelectorAll('[data-keauty-shipping-goals]')) {
      const currency = cart?.currency || root.dataset.cartCurrency;
      const shopCurrency = root.dataset.shopCurrency;
      const activeCurrency = window.Shopify?.currency?.active;
      const milestoneCurrency = root.dataset.milestoneCurrency || shopCurrency;
      const rate = currency === milestoneCurrency ? 1 :
        (milestoneCurrency !== shopCurrency ? NaN :
          (!activeCurrency || activeCurrency === currency ? Number(window.Shopify?.currency?.rate) : NaN));
      // Shopify total_price already includes cart-level discounts; never deduct them twice.
      const total = cart ? Number(cart.total_price) : Number(root.dataset.cartTotal);
      let milestones;
      try { milestones = JSON.parse(root.dataset.milestones); } catch (_) { milestones = []; }
      const result = calculate(milestones, total, rate);
      const goal = root.querySelector('[data-keauty-goal]');
      const status = root.querySelector('[data-keauty-goal-status]');
      const service = root.querySelector('[data-keauty-goal-service]');
      const fallback = root.querySelector('[data-keauty-goal-fallback]');
      if (!goal || !status || !service) continue;
      let message;
      try {
        message = result && (result.unlocked ? root.dataset.finalLabel : result.target.msg.replace('__KEAUTY_AMOUNT__', formatMoney(result.remaining, currency)));
      } catch (_) { message = null; }
      goal.hidden = !message;
      if (fallback) fallback.hidden = Boolean(message);
      if (!message) continue;
      goal.setAttribute('threshold', String(result.target.cents));
      goal.style.setProperty('--progress', String(result.progress));
      status.textContent = message;
      service.textContent = result.target.svc || '';
    }
  }
  window.keautyShippingGoals = { update, calculate };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update(), { once: true });
  else update();
  document.documentElement.addEventListener('cart:updated', event => update(event.detail?.cart));
  document.documentElement.addEventListener('cart:refresh', event => {
    update(event.detail?.cart);
    requestAnimationFrame(() => update(event.detail?.cart));
  });
  document.documentElement.addEventListener('keauty:cart-rendered', event => update(event.detail?.cart));
  document.addEventListener('shopify:section:load', () => update());
})();
